import { render, staticRenderFns } from "./kf.vue?vue&type=template&id=439a9a52&scoped=true"
import script from "./kf.vue?vue&type=script&lang=js"
export * from "./kf.vue?vue&type=script&lang=js"
import style0 from "./kf.vue?vue&type=style&index=0&id=439a9a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a9a52",
  null
  
)

export default component.exports